module.exports = __webpack_public_path__ + "img/welcome.55d2873e.png";